import { submit_ga_event_click } from "helpers/analytics-helpers"
import { IS_AU, jewlr_t } from "helpers/application"
import { instantGiftVideoData as getInstantGiftVideoData } from "helpers/holiday"
import { getImgSrcSet } from "helpers/image"

const instantGiftVideoData = getInstantGiftVideoData()
const getTitleFolder = () => (IS_AU() ? "au/" : "na/")

const mothersDayData = () => {
  const titleFolder = getTitleFolder()
  return {
    style: {
      left: {
        desktop: "19%",
        tablet: "3%",
        widescreen: "12%",
      },
      px: 2,
      top: {
        _: "10%",
        tablet: "50%",
      },
      width: {
        _: "100%",
        desktop: "375px",
        tablet: "400px",
        widescreen: "430px",
      },
    },
    texts: [
      {
        alt: "Gift Preview Video For Mom",
        fallback: `${require(`images/instant-gifts/explained/main_banner/mothersday/${titleFolder}title.svg`)}`,
        srcSet: [
          {
            media: "(max-width: 767px)",
            sizes: "100vw",
            srcSet: `${require(`images/instant-gifts/explained/main_banner/mothersday/${titleFolder}title_mobile.svg`)}`,
          },
          {
            media: "(min-width: 768px)",
            sizes: "100vw",
            srcSet: `${require(`images/instant-gifts/explained/main_banner/mothersday/${titleFolder}title.svg`)}`,
          },
        ],
        style: {
          mb: 2,
          width: {
            _: "250px",
            tablet: "95%",
          },
        },
        type: "image",
      },
      {
        style: {
          fontSize: {
            _: "20px",
            tablet: "22px",
          },
          letterSpacing: "normal",
          light: false,
          mb: 0,
        },
        text: "Order Today, Share Right Away!",
        type: "description",
      },
    ],
  }
}

const mothersDay2024Data = () => {
  const titleFolder = getTitleFolder()
  return {
    style: {
      left: "auto",
      px: {
        _: "14%",
        tablet: 2,
      },
      right: {
        _: "0",
        desktop: "5%",
        tablet: "0%",
        widescreen: "2%",
      },
      top: {
        _: "14%",
        tablet: "50%",
      },
      width: {
        _: "100%",
        desktop: "56%",
        tablet: "50%",
        widescreen: "60%",
      },
    },
    texts: [
      {
        alt: `A Gift Preview Video for ${jewlr_t(
          "terms.Mom"
        )} - Order Today, Share Right Away!`,
        fallback: `${require(`images/instant-gifts/explained/main_banner/2024-mothers-day/${titleFolder}title_desktop.svg`)}`,
        srcSet: [
          {
            media: "(max-width: 767px)",
            sizes: "100vw",
            srcSet: `${require(`images/instant-gifts/explained/main_banner/2024-mothers-day/${titleFolder}title_mobile.svg`)}`,
          },
          {
            media: "(min-width: 768px) and (max-width: 1023px)",
            sizes: "100vw",
            srcSet: `${require(`images/instant-gifts/explained/main_banner/2024-mothers-day/${titleFolder}title_tablet.svg`)}`,
          },
          {
            media: "(min-width: 1024px)",
            sizes: "100vw",
            srcSet: `${require(`images/instant-gifts/explained/main_banner/2024-mothers-day/${titleFolder}title_desktop.svg`)}`,
          },
        ],
        style: {
          maxWidth: {
            _: "100%",
            xlarge: "140%",
          },
          width: {
            _: "100%",
            desktop: "87%",
            tablet: "95%",
            xlarge: "140%",
          },
        },
        type: "image",
      },
    ],
  }
}

const genericData = () => ({
  style: {
    left: {
      tablet: "18%",
    },
    px: 2,
    top: {
      _: "10%",
      tablet: "50%",
    },
    width: {
      _: "100%",
      desktop: "450px",
      tablet: "350px",
    },
  },
  texts: [
    {
      style: {
        fontSize: {
          _: 26,
          tablet: 30,
        },
        fontWeight: 500,
        mb: 0,
      },
      text: "Gift Preview Video",
      type: "title",
    },
    {
      style: {
        fontSize: {
          _: "20px",
          tablet: "22px",
        },
        letterSpacing: "normal",
        light: false,
        mb: 0,
      },
      text: "Order Today, Share Right Away!",
      type: "description",
    },
  ],
})

const holidayData = () => ({
  style: {
    left: "auto",
    px: {
      _: 5,
      tablet: 2,
    },
    py: 0,
    textAlign: "center",
    top: {
      _: "20%",
      tablet: "50%",
    },
    width: "100%",
  },
  textBlockStyle: {
    mx: "auto",
    width: {
      tablet: "584px",
    },
  },
  texts: [
    {
      style: {
        fontSize: {
          _: 26,
          tablet: 30,
        },
        fontWeight: 500,
        mb: 0,
      },
      text: "Gift Preview Video",
      type: "title",
    },
    {
      style: {
        fontSize: {
          _: "20px",
          tablet: "22px",
        },
        letterSpacing: "normal",
        light: false,
        mb: {
          _: 2,
          widescreen: 3,
        },
      },
      text: "Order Today, Share Right Away!",
      type: "description",
    },
    {
      style: {
        fontSize: {
          _: "20px",
          tablet: "22px",
        },
        letterSpacing: "normal",
        mb: 0,
      },
      text: `The perfect last-minute gifting solution! Create and
      purchase a meaningful, ${jewlr_t("terms.personalized")} gift,
      and have it sent virtually to a loved one using our Gift
      Preview Video option. Your actual gift arrives a${" "}
      <span className="nowrap">few days later.</span>`,
      type: "description",
    },
  ],
})

const valentinesData = () => ({
  style: {
    left: "auto",
    textAlign: "center",
    top: {
      _: "30%",
      tablet: "50%",
    },
    width: "100%",
  },
  textBlockStyle: {
    mx: "auto",
    width: {
      _: "75%",
      tablet: "400px",
    },
  },
  texts: [
    {
      style: {
        as: "h1",
        color: "#D14275",
        fontSize: 30,
        fontWeight: 700,
        mb: 1,
      },
      text: "Gift Preview Video",
      type: "title",
    },
    {
      style: {
        bold: true,
        fontSize: {
          _: "20px",
          tablet: "22px",
        },
        letterSpacing: "normal",
        light: false,
        mb: {
          _: 2,
          widescreen: 3,
        },
      },
      text: "Order Today, Share Right Away!",
      type: "description",
    },
    {
      style: {
        fontSize: {
          _: "20px",
          tablet: "22px",
        },
        letterSpacing: "normal",
        light: false,
        mb: 0,
      },
      text: `The perfect last-minute gifting solution! Create and
      purchase a meaningful, ${jewlr_t("terms.personalized")}${" "}
      gift, and have it sent virtually to a loved one using our
      Gift Preview Video option. Your actual gift arrives a${" "}
      <span className="nowrap">few days later.</span>`,
      type: "description",
    },
  ],
})

const fathersdayData = () => ({
  style: {
    left: {
      desktop: "18%",
      tablet: "7%",
    },
    px: 2,
    top: {
      _: "10%",
      tablet: "50%",
    },
    width: {
      _: "100%",
      desktop: "450px",
      tablet: "350px",
    },
  },
  texts: [
    {
      style: {
        fontSize: {
          _: 26,
          tablet: 30,
        },
        fontWeight: 500,
        mb: 0,
      },
      text: "Gift Preview Video",
      type: "title",
    },
    {
      style: {
        fontSize: {
          _: "20px",
          tablet: "22px",
        },
        letterSpacing: "normal",
        light: false,
        mb: 0,
      },
      text: "Order Today, Share Right Away!",
      type: "description",
    },
  ],
})

export const instantGiftData = () => {
  let textareaData = genericData()
  const instantGiftVideoData = getInstantGiftVideoData()
  const bgImgFolder = instantGiftVideoData.main_banner
  const mainBannerFolder = instantGiftVideoData.main_banner_folder

  let mainBannerStyle = {
    pb: {
      _: "121.2%",
      desktop: "22.76%",
      tablet: "43.28%",
    },
  }

  if (instantGiftVideoData.main_banner === "mothersday") {
    textareaData = mothersDayData()
  } else if (instantGiftVideoData.main_banner === "holiday") {
    textareaData = holidayData()
  } else if (instantGiftVideoData.main_banner === "valentines") {
    textareaData = valentinesData()
  } else if (instantGiftVideoData.main_banner === "fathersday") {
    textareaData = fathersdayData()
  } else if (instantGiftVideoData.main_banner?.startsWith("2024-mothers-day")) {
    textareaData = mothersDay2024Data()
    mainBannerStyle = {
      pb: {
        _: "94.52%",
        desktop: "19.53%",
        tablet: "36.62%",
      },
    }
  }

  const mainBanner = mainBannerFolder
    ? {
        alt: "Gift Preview Video - Order today, share right away!",
        desktop_2x: `${sl.config.jewlr_asset_url}${mainBannerFolder}/desktop_2x.jpg`,
        srcSet: [
          {
            height: "928",
            media: "(max-width: 767px)",
            sizes: "100vw",
            srcSet: `${sl.config.jewlr_asset_url}${mainBannerFolder}/mobile.jpg 767w,
      ${sl.config.jewlr_asset_url}${mainBannerFolder}/mobile_2x.jpg 1534w`,
            width: "767",
          },
          {
            height: "435",
            media: "(min-width: 768px) and (max-width: 1023px)",
            sizes: "100vw",
            srcSet: `${sl.config.jewlr_asset_url}${mainBannerFolder}/tablet.jpg 1005w,
      ${sl.config.jewlr_asset_url}${mainBannerFolder}/tablet_2x.jpg 2010w`,
            width: "1005",
          },
          {
            height: "437",
            media: "(min-width: 1024px)",
            sizes: "100vw",
            srcSet: `${sl.config.jewlr_asset_url}${mainBannerFolder}/desktop.jpg 1920w,
      ${sl.config.jewlr_asset_url}${mainBannerFolder}/desktop_2x.jpg 3840w`,
            width: "1920",
          },
        ],
      }
    : {
        alt: "Gift Preview Video - Order today, share right away!",
        desktop_2x: `${require(`images/instant-gifts/explained/main_banner/${bgImgFolder}/desktop_2x.jpg`)}`,
        srcSet: [
          {
            height: "928",
            media: "(max-width: 767px)",
            sizes: "100vw",
            srcSet: `${require(`images/instant-gifts/explained/main_banner/${bgImgFolder}/mobile.jpg`)} 767w,
   ${require(`images/instant-gifts/explained/main_banner/${bgImgFolder}/mobile_2x.jpg`)} 1534w`,
            width: "767",
          },
          {
            height: "435",
            media: "(min-width: 768px) and (max-width: 1023px)",
            sizes: "100vw",
            srcSet: `${require(`images/instant-gifts/explained/main_banner/${bgImgFolder}/tablet.jpg`)} 1005w,
   ${require(`images/instant-gifts/explained/main_banner/${bgImgFolder}/tablet_2x.jpg`)} 2010w`,
            width: "1005",
          },
          {
            height: "437",
            media: "(min-width: 1024px)",
            sizes: "100vw",
            srcSet: `${require(`images/instant-gifts/explained/main_banner/${bgImgFolder}/desktop.jpg`)} 1920w,
   ${require(`images/instant-gifts/explained/main_banner/${bgImgFolder}/desktop_2x.jpg`)} 3840w`,
            width: "1920",
          },
        ],
      }

  return {
    image: mainBanner,
    style: {
      mb: 0,
      ...mainBannerStyle,
    },
    textarea: textareaData,
  }
}

export const banner = () => ({
  contain: true,
  data: {
    items: [
      {
        image: {
          alt: "Gift Preview Video - Order today, share right away!",
          fallback:
            "https://cms.jewlr.com/gift_preview_video_2x_8d86d1a4fe/gift_preview_video_2x_8d86d1a4fe.jpg",
          srcSet: [
            {
              height: "750",
              media: "(max-width: 767px)",
              sizes: "100vw",
              srcSet: getImgSrcSet(
                `${sl.config.jewlr_imgsmbly_url}cms/m_gift_preview_video_2x_4ac565a4e6/m_gift_preview_video_2x_4ac565a4e6.jpg`,
                750
              ),
              width: "750",
            },
            {
              height: "800",
              media: "(min-width: 768px)",
              sizes: "(max-width: 1920px) 100vw, 1920px",
              srcSet: getImgSrcSet(
                `${sl.config.jewlr_imgsmbly_url}cms/gift_preview_video_2x_8d86d1a4fe/gift_preview_video_2x_8d86d1a4fe.jpg`,
                2880
              ),
              width: "2880",
            },
          ],
        },
        style: {
          display: { _: "flex", tablet: "block" },
          flexDirection: "column",
        },
        text_container_style: {
          justifyContent: "flex-end",
          order: -1,
          pb: { _: 3, tablet: "40px" },
          position: { _: "unset", tablet: "absolute" },
          pt: { _: 3, tablet: "40px" },
          px: { _: 2, tablet: "40px" },
        },

        texts: [
          {
            style: {
              fontSize: {
                _: "48px",
                desktop: "56px",
                widescreen: "96px",
              },
              mb: { desktop: 5, tablet: 2 },
            },
            text: "Gift Preview<br/>Video",
            type: "title",
          },
          {
            text:
              "Last-minute gifting? Create and preview <br/>today – your order ships fast!",
            variant: "body-lg",
          },
        ],
      },
    ],
  },
})

export const whatTheyGet = () => ({
  data: {
    media_position: "right",
  },
  style: {
    container_style: {
      flexDirection: { _: "column", tablet: "row" },
      p: 0,
    },
    text_container_style: { flex: "0 0 35%" },
  },
  textarea: {
    texts: [
      {
        style: { mb: "20px" },
        text: "What They Get",
        type: "homepage_heading",
      },
      {
        style: { mb: "20px" },
        text:
          "Your loved one receives a video of their custom gift and your personal message.",
        type: "description",
      },
      {
        base_style: "underline",
        style: {
          display: "inline-flex",
          fontWeight: 600,
          pb: 0,
        },
        text: "SHOP NOW",
        type: "link",
        url: "/",
      },
    ],
  },
  video: {
    options: {
      autoPlay: false,
      controls: true,
      loop: false,
      muted: false,
      onPlay: () => submit_ga_event_click("Instant Gift", "Play Video"),
    },
    srcsets: [
      {
        height: "1080",
        poster: `${sl.config.jewlr_asset_url}instant-gift/thumbnails/${instantGiftVideoData.video}.jpg`,
        srcset: [
          {
            src: `${sl.config.jewlr_asset_url}instant-gift/videos/${instantGiftVideoData.video}.mp4`,
            type: "video/mp4",
          },
        ],
        width: "1920",
      },
    ],
  },
})
